import React from 'react';
import { FAIcon, Theme, SearchDataStructure, AttributeTypes, Tag, TagStyle } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';

type ICoachBO = {
  [key: string]: DynamicObjectInterface;
};

const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Coach ID',
    key: 'coachID',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Coach Name',
    key: 'name',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'ABO ID',
    key: 'aboID',
    type: AttributeTypes.Textbox,
    visibility: false,
  },
  {
    name: 'Status',
    key: 'status',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: false,
    dataset: [
      {
        key: 'true',
        value: 'ACTIVE',
      },
      {
        key: 'false',
        value: 'INACTIVE',
      },
    ],
  },
];

const getCoachListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  {
    key: 'campaignId',
    text: translation('admin.coachMaster.campaignId'),
    sortable: true,
    width: 9,
    render: (object: ICoachBO) => <span>{object.campaignId}</span>,
  },
  {
    key: 'coachID',
    text: translation('admin.coachMaster.coachID'),
    sortable: true,
    width: 9,
    render: (object: ICoachBO) => <span>{object.coachID}</span>,
  },
  {
    key: 'aboID',
    text: translation('admin.coachMaster.aboID'),
    sortable: true,
    width: 8,
    render: (object: ICoachBO) => <span>{object.aboID}</span>,
  },
  {
    key: 'name',
    text: translation('admin.coachMaster.name'),
    sortable: true,
    width: 10,
    render: (object: ICoachBO) => <span>{object.name}</span>,
  },
  {
    key: 'contact',
    text: translation('admin.coachMaster.contact'),
    sortable: true,
    width: 12,
    render: (object: ICoachBO) => <span>{object.contact}</span>,
  },
  {
    key: 'email',
    text: translation('admin.coachMaster.email'),
    sortable: true,
    width: 17,
    render: (object: ICoachBO) => <span>{object.email}</span>,
  },
  {
    key: 'remark',
    text: translation('admin.coachMaster.remark'),
    sortable: true,
    width: 15,
    render: (object: ICoachBO) => <span>{object.remark}</span>,
  },
  {
    key: 'status',
    text: translation('admin.coachMaster.status'),
    sortable: true,
    width: 6,
    render: (object: ICoachBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
    key: 'action',
    width: 5,
    text: translation('admin.coachMaster.action'),
    render: (object: ICoachBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onClick(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export default getCoachListConfig;
export { dataSearchOption };
